import React from 'react'
import { Field, change } from 'redux-form'

import useDispatch from 'hooks/useDispatch'

import InlineSpinner from '../display/InlineSpinner'

import PlacesInput from '../form/PlacesInput'
import { renderError, Label, InputGroup } from '../form'
import { validRequired } from '../form/validate'

export const validLocation = (_value, values) => {
  if (!values.user.latitude || !values.user.longitude) {
    return 'Please select a valid location from the dropdown'
  }

  return undefined
}

const UserLocationField = ({ formName, ready, noMargin }) => {
  const dispatch = useDispatch()

  return (
    <InputGroup lessMargin noMargin={noMargin}>
      <Label htmlFor="user[location]">Location</Label>
      <Field
        name="user[location]"
        component={ready === false ? InlineSpinner : PlacesInput}
        validate={[validRequired, validLocation]}
        onlyRegions
        onSelectChange={({ location, latitude, longitude }) => {
          if (location) {
            dispatch(change(formName, 'user[location]', location))
          }
          dispatch(change(formName, 'user[latitude]', latitude))
          dispatch(change(formName, 'user[longitude]', longitude))
        }}
        rounded
        placeholder="Enter your location (city, country)"
      />
      <Field
        name="user[location]"
        component={renderError}
        validate={[validRequired, validLocation]}
        rounded
      />
      <Field name="user[latitude]" component="input" type="hidden" />
      <Field name="user[longitude]" component="input" type="hidden" />
    </InputGroup>
  )
}

export default UserLocationField
